if (!customElements.get('designer-profile')) {
  class DesignerProfile extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick(event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey) return;

      const link = event.target.closest('a[href*="#"]');
      if (!link || !this.contains(link)) return;

      const href = link.getAttribute('href') || '';
      const hashIndex = href.indexOf('#');
      const id = hashIndex === -1 ? '' : href.slice(hashIndex + 1);
      if (!id || (hashIndex > 0 && link.pathname !== window.location.pathname)) return;

      const target = document.getElementById(id);
      if (!target) return;

      event.preventDefault();

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });

      if (!target.hasAttribute('tabindex')) {
        target.setAttribute('tabindex', '-1');
      }
      target.focus({ preventScroll: true });
    }
  }

  customElements.define('designer-profile', DesignerProfile);
}
